import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { isKnownRoute, localizedPath, stripLanguage } from '../../shared/constants/routes';

/**
 * Catch-all for URLs that carry no language prefix (legacy links, local dev)
 * and for unknown paths. Sends them to the language-prefixed equivalent, or to
 * the home page if the route does not exist.
 */
export const LanguageRedirect: React.FC = () => {
  const { language } = useLanguage();
  const location = useLocation();

  const { path } = stripLanguage(location.pathname);
  const target = isKnownRoute(path) ? path : '/';

  return (
    <Navigate to={`${localizedPath(target, language)}${location.search}${location.hash}`} replace />
  );
};
